import { render, staticRenderFns } from "./CurrencyWrapper.vue?vue&type=template&id=7b32e858&scoped=true&"
import script from "./CurrencyWrapper.vue?vue&type=script&lang=js&"
export * from "./CurrencyWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyWrapper.vue?vue&type=style&index=0&id=7b32e858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32e858",
  null
  
)

export default component.exports